import { TSystemSettingValueCommon, TSystemSettingValueCommonResponse } from './system-setting-value.type';
import { adaptUserMetaUndefinedFromResponse } from './user-meta.type';


export type TSystemSettingUsersAccountUserType = TSystemSettingValueCommon & {
  value?: number;
};

export type TSystemSettingUsersAccountUserTypeResponse = TSystemSettingValueCommonResponse & {
  value?: number;
};

export type TSystemSettingUsersAccountUserTypePayload = {
	value?: number;
};

export type TSystemSettingUsersAccountUserTypeRequest = {
	value?: number;
};

export function adaptSystemSettingUsersAccountUserTypeFromResponse(data: TSystemSettingUsersAccountUserTypeResponse): TSystemSettingUsersAccountUserType {
	const {
		public_id: publicId,
		name,
		value,
		description,
		created_at: createdAt,
		updated_at: updatedAt,
		created_by: createdByRaw,
		updated_by: updatedByRaw,
	} = data;

	const createdBy = adaptUserMetaUndefinedFromResponse(createdByRaw);
	const updatedBy = adaptUserMetaUndefinedFromResponse(updatedByRaw);

	return {
		publicId,
		name,
		value,
		description,
		createdAt,
		updatedAt,
		createdBy,
		updatedBy,
	};
}

export function adaptSystemSettingUsersAccountUserTypeToRequest(data: TSystemSettingUsersAccountUserTypePayload): TSystemSettingUsersAccountUserTypeRequest {
	const { value = '' } = data;

	return {
		value: value ? value : undefined,
	};
}
